/* ────────────────────────────────────────────────────────────────
   HS dynamische levertijd — variant-wissel.
   Werkt samen met snippets/hs-delivery-eta.liquid: dat rendert de
   begintekst + een JSON-map { variantId: waarde }. De waarde is een
   aantal dagen (getal) óf een vaste leverdatum ("YYYY-MM-DD", bv.
   bij een vakantie-override per merk). Bij een variant-wissel
   (Dawn PUB_SUB variantChange) rekenen we de datum opnieuw en
   werken we de tekst bij. Zelfde formattering als de Liquid →
   geen mismatch.
   ──────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var NL_DAYS = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  var NL_MONTHS = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli',
                   'augustus', 'september', 'oktober', 'november', 'december'];

  function formatDate(d) {
    return 'Vandaag besteld, uiterlijk ' + NL_DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + NL_MONTHS[d.getMonth()] + ' in huis.';
  }

  function etaText(days) {
    /* vandaag + N dagen, maar alleen ma t/m za tellen (zondag = 0 telt niet mee) */
    var d = new Date();
    var count = 0;
    while (count < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) count += 1;
    }
    return formatDate(d);
  }

  function fixedText(iso) {
    /* iso = 'YYYY-MM-DD' — vaste leverdatum uit de override in de snippet */
    var p = iso.split('-');
    var d = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]), 12, 0, 0);
    return formatDate(d);
  }

  function readMap() {
    var node = document.querySelector('[data-hs-eta-map]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function update(variantId) {
    if (variantId == null) return;
    var map = readMap();
    if (!map) return;
    var val = map[String(variantId)];
    if (val == null) return;
    var el = document.querySelector('[data-hs-eta-text]');
    if (el) el.textContent = (typeof val === 'string') ? fixedText(val) : etaText(val);
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.variantChange) {
      return; /* geen Shopify-omgeving */
    }
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var v = event && event.data && event.data.variant;
      if (v && v.id != null) update(v.id);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
